import { render, staticRenderFns } from "./ReportProductImages.vue?vue&type=template&id=20369c66"
import script from "./ReportProductImages.vue?vue&type=script&lang=js"
export * from "./ReportProductImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20369c66')) {
      api.createRecord('20369c66', component.options)
    } else {
      api.reload('20369c66', component.options)
    }
    module.hot.accept("./ReportProductImages.vue?vue&type=template&id=20369c66", function () {
      api.rerender('20369c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/ReportProductImages.vue"
export default component.exports